import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

/**
 * AiWorkoutService
 * Front-end service para comunicação com a Cloud Function generateWorkout.
 * A API Key NUNCA é acessada no front — tudo acontece no backend.
 */
const AiWorkoutService = {
    /**
     * Gera um treino de natação via IA.
     * @param {Object} params
     * @param {string} params.provider - "openai" ou "gemini"
     * @param {string} params.objective - Objetivo do treino
     * @param {string} params.level - Nível dos alunos
     * @param {number} params.meters - Metragem total alvo
     * @param {number} [params.duration] - Duração em minutos (opcional)
     * @param {string[]} [params.styles] - Estilos preferenciais (opcional)
     * @param {string} [params.notes] - Observações adicionais (opcional)
     * @returns {Object} { success, workout: { title, description, blocks } }
     */
    generate: async (params) => {
        const fn = httpsCallable(functions, "generateWorkout");
        const result = await fn(params);
        return result.data;
    },
};

export default AiWorkoutService;
